import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6524f308"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container px-0 py-9",
  id: "wrapper-div"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-error",
  role: "alert"
}
const _hoisted_6 = { class: "alert-body" }
const _hoisted_7 = { class: "alert-heading" }
const _hoisted_8 = { class: "alert-text" }
const _hoisted_9 = ["data-cy"]
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = {
  class: "form-label",
  for: "calculation-export-name"
}
const _hoisted_12 = ["disabled", "data-error", "pattern"]
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  class: "container px-0 py-9",
  id: "wrapper-div"
}
const _hoisted_16 = {
  key: 0,
  class: "row"
}
const _hoisted_17 = { class: "accordion" }
const _hoisted_18 = {
  class: "accordion-button",
  "aria-expanded": "false",
  "aria-controls": "a1"
}
const _hoisted_19 = {
  id: "a1",
  "aria-hidden": "false",
  class: "accordion-content"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  class: "table--responsive-scroll",
  style: {"height":"550px","overflow":"auto"}
}
const _hoisted_23 = { class: "table w-percent-100" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", null, null, -1))
const _hoisted_25 = {
  key: 0,
  id: "excel-file-name",
  colspan: "5",
  style: {"text-align":"center"}
}
const _hoisted_26 = {
  style: {"width":"15%"},
  id: "validate_error_type"
}
const _hoisted_27 = {
  style: {"width":"40%"},
  id: "validate_error_description"
}
const _hoisted_28 = { style: {"width":"15%"} }
const _hoisted_29 = { style: {"width":"40%"} }
const _hoisted_30 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_SharedHeader = _resolveComponent("SharedHeader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SharedHeader, { tabMenu: _ctx.menu }, {
      firstColumn: _withCtx(() => [
        _createElementVNode("h1", null, [
          _createVNode(_component_SimpleText, { "text-key": "import-export.import.headerTitle" })
        ]),
        _createElementVNode("p", null, [
          _createVNode(_component_SimpleText, { "text-key": "import-export.import.headerText" })
        ])
      ]),
      _: 1
    }, 8, ["tabMenu"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("input", {
            ref: "fileUpload",
            type: "file",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addFile && _ctx.addFile(...args))),
            hidden: ""
          }, null, 544),
          _createElementVNode("button", {
            class: "button button-secondary adjust-button-size",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectFile && _ctx.selectFile(...args)))
          }, [
            _createVNode(_component_SimpleText, { "text-key": "import-export.import.select-file" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.calculation.calculationPurpose)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              id: "purpose",
              onChange: _cache[4] || (_cache[4] = ($event: any) => {_ctx.formValidation.clearValidField($event);}),
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.importFile()), ["prevent"])),
              onInvalidCapture: _cache[6] || (_cache[6] = _withModifiers(($event: any) => {_ctx.formValidation.handleFormValidity($event, true);}, ["prevent"]))
            }, [
              (_ctx.formValidation.formErrors.size)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, [
                        _createVNode(_component_SimpleText, { "text-key": "sharedContent.formErrorTitle" })
                      ]),
                      _createElementVNode("ul", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formValidation.formErrors, ([key, value]) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: key,
                            "data-cy": 'error_' + key
                          }, _toDisplayString(value), 9, _hoisted_9))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, [
                  _createVNode(_component_SimpleText, { "text-key": "import-export.export.calculation-name-in-export" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "calculation-export-name",
                  class: "form-input",
                  type: "text",
                  disabled: !_ctx.isCalculationSelected(),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.calculationName) = $event)),
                  "data-error": _ctx.nameOfCalculationError,
                  maxlength: "40",
                  pattern: _ctx.findRegexPattern('regex.validation.calculation-name'),
                  required: ""
                }, null, 8, _hoisted_12), [
                  [_vModelText, _ctx.calculationName]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  class: "button button-primary adjust-button-size",
                  disabled: !_ctx.isReadyForImport(),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.importFile()))
                }, [
                  _createVNode(_component_SimpleText, { "text-key": "import-export.import.import-file" })
                ], 8, _hoisted_14)
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_ctx.isShowAccordion())
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("ul", _hoisted_17, [
                _createElementVNode("li", null, [
                  _createElementVNode("h2", null, [
                    _createElementVNode("button", _hoisted_18, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['accordion-title', { 'error': _ctx.isStatusError() }, { 'warning': _ctx.isStatusWarning() }])
                      }, _toDisplayString(_ctx.getStatusText()), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    (_ctx.validationErrors.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          (_ctx.jsonFileName.fileName)
                            ? (_openBlock(), _createElementBlock("h2", _hoisted_21, _toDisplayString(_ctx.getErrorTableTitle()), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("table", _hoisted_23, [
                              _hoisted_24,
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  (_ctx.jsonFileName.fileName)
                                    ? (_openBlock(), _createElementBlock("th", _hoisted_25, _toDisplayString(_ctx.jsonFileName.fileName), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.getContentfulString('import-export.import.error-type.title')), 1),
                                  _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.getContentfulString('import-export.import.error-type.error-import')), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationErrors, (item) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: item.name
                                  }, [
                                    _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.getErrorTypeMessage(item.name)), 1),
                                    _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.getContentfulStringAndReplacePlaceholders(item.textKey ?? "NA", item.parameters)), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.getStatusText()), 1))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}